/** Площадки, отключённые этому человеку в админке (сервер: venue_access.py,
 *  поле `disabled_exchanges` в /api/settings, с раскрытыми дексами HL).
 *
 *  Сервер сам вырезает их из данных (сканер, фандинг, списки бирж и символов,
 *  WS) и отвечает 403 на ключ/сессию/пресет с ними. Здесь — только статичные
 *  списки фронта (выпадашки терминала, алертов, пресетов, ключей), которые
 *  берутся не с сервера. */
import { useCallback, useMemo } from 'react';
import { useAppStore } from '../store/useStore';

const EMPTY: readonly string[] = [];

/** Набор отключённых площадок текущего пользователя (реактивно). */
export function useDisabledVenues(): ReadonlySet<string> {
  const list = useAppStore(s => s.user?.disabled_exchanges) ?? EMPTY;
  return useMemo(() => new Set(list), [list]);
}

/** `(список) → список без отключённых`. Пустой набор — тот же массив. */
export function useVenueFilter(): <T extends string>(list: readonly T[]) => T[] {
  const off = useDisabledVenues();
  return useCallback(<T extends string>(list: readonly T[]): T[] =>
    (off.size ? list.filter(v => !off.has(v)) : (list as T[])), [off]);
}
